import { render, staticRenderFns } from "./VariantPayment.vue?vue&type=template&id=0a9e4d1e&lang=pug&"
import script from "./VariantPayment.vue?vue&type=script&lang=js&"
export * from "./VariantPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports